import { ChamberSelect, type UsFilters, UsStateSelect, UsTableFilters } from 'components/index'
import { FormControl } from '@mui/material'
import React, { useEffect } from 'react'
import { LeadershipOfficerTypeSelect } from './leadership-officer-type-select'
import { FEDERAL_CHAMBERS, FEDERAL_LEADERSHIP_OFFICER_ROLES, STATE_CHAMBERS } from 'utils'
import { type Role } from 'services'

interface LeadershipOfficerFilterProps {
  filters: UsFilters
  updateFilters: (filters: any) => void
  doFilter: () => Promise<void>
  cleanFilters: () => void
}

export const LeadershipOfficerFilters: React.FC<LeadershipOfficerFilterProps> = ({ filters, updateFilters, doFilter, cleanFilters }) => {
  const isFederalOrEmptyRole = (role?: Role): boolean => role == null || FEDERAL_LEADERSHIP_OFFICER_ROLES.includes(role.id)

  const validateStateSelection = (): null | typeof filters.state => (filters.role === null || (isFederalOrEmptyRole(filters.role) && filters.state !== null) ? null : filters.state)

  const validateChamberSelection = (): null | typeof filters.chamber => {
    if (filters.chamber == null) return null
    const validChambers = isFederalOrEmptyRole(filters.role) ? FEDERAL_CHAMBERS : STATE_CHAMBERS
    return (validChambers.map(c => c.id).includes(filters.chamber.id)) ? filters.chamber : null
  }

  useEffect(() => {
    updateFilters({ chamber: validateChamberSelection(), state: validateStateSelection() })
  }, [filters.role])

  return (
    <UsTableFilters doFilter={doFilter} filters={filters} updateFilters={updateFilters} cleanFilters={cleanFilters}>
      <FormControl variant="outlined" fullWidth={true}>
        <LeadershipOfficerTypeSelect value={filters.role} updateLeadershipOfficerType={(role) => { updateFilters({ role }) }} disabled={false}/>
      </FormControl>
      <FormControl variant="outlined" fullWidth={true}>
        <UsStateSelect disabled={isFederalOrEmptyRole(filters.role)} value={filters.state} updateState={(state) => { updateFilters({ state }) }}/>
      </FormControl>
      <FormControl variant="outlined" fullWidth={true}>
        <ChamberSelect
          updateChamber={(chamber) => { updateFilters({ chamber }) }}
          disabled={filters.role == null}
          onlyFederal={isFederalOrEmptyRole(filters.role)}
          onlyState={!isFederalOrEmptyRole(filters.role)}
          value={filters.chamber}
        />
      </FormControl>
    </UsTableFilters>
  )
}
